import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n/i18n";
import App from "./App.tsx";
import { changeLocale } from "./i18n";
import { readQueryParams } from "./lib/bridge";

const { locale } = readQueryParams();
void changeLocale(locale);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
